import { useState } from 'react';
import { useSnackbar } from '@/alerts/index';
import { useAppConstantsContext } from '@/context/AppConstants';
import { Box, Button, Divider, Stack, Text } from '@/theme/index';

interface PremiumDataCtaVariationProps {
  nmvtisSuccess?: boolean;
  reportUpgraded: boolean;
  handleFreeUpgrade: () => void;
}
export const PremiumDataCtaVariation = ({
  nmvtisSuccess,
  reportUpgraded,
  handleFreeUpgrade,
}: PremiumDataCtaVariationProps) => {
  const {
    images: { imgPremiumData },
  } = useAppConstantsContext();
  const { enqueueSnackbar } = useSnackbar();
  const [upgradeReportCalled, setUpgradeReportCalled] = useState(false);

  const handleUpgrade = () => {
    handleFreeUpgrade();
    setUpgradeReportCalled(true);
  };

  if (reportUpgraded && !nmvtisSuccess && upgradeReportCalled) {
    enqueueSnackbar('Report upgrade failed. Please try again.', {
      variant: 'error',
    });
    setUpgradeReportCalled(false);
  }

  return (
    <Stack textAlign="center">
      <Divider sx={{ borderStyle: 'dashed', borderBottomWidth: 'medium' }} />
      <Box ml="auto" mr="auto" position="relative" bottom="28px" height="28px">
        <img src={imgPremiumData?.imgPremiumSearchIcon} alt="Premium Data" />
      </Box>
      <Stack
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        p={2}
      >
        <Stack direction="column">
          <Text
            variant="h3"
            sx={{ mb: 2 }}
            data-testid="premium-data-cta-title"
          >
            Additional information may be available.
          </Text>
          <Text
            variant="body1"
            sx={{ mb: 2 }}
            data-testid="premium-data-cta-body"
          >
            Get access to a range of bonus data including NMVTIS title records
            and salvage information in your vehicle report.
          </Text>
        </Stack>
        <Button
          variant="contained"
          onClick={handleUpgrade}
          color="success"
          data-testid="premium-data-cta-button"
        >
          View Records
        </Button>
      </Stack>
    </Stack>
  );
};
